import LoyaltyClaimPoints from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-claim-points/index';

export default LoyaltyClaimPoints;
